import { inject, Injectable } from "@angular/core";
import { Observable } from 'rxjs';
import { environment } from "../../../environments/environment";
import { HttpService } from "../../shared/services/http.service";


@Injectable({providedIn: 'root'})
export class WpApprovalService {
    private approvalList = `${environment.opbBackendHost}/api/admin/approval/list`; 
    private approveAdd = `${environment.opbBackendHost}/api/admin/approval/approve`; 

    httpService=inject(HttpService);

    getList(data: any): Observable<any> {
        return this.httpService.post(this.approvalList,data);
    }

    addApprove(data: any): Observable<any> {
        return this.httpService.post(this.approveAdd,data);
    }

}